import { render, staticRenderFns } from "./UploadOrRecordPage.vue?vue&type=template&id=85456a1e&scoped=true"
import script from "./UploadOrRecordPage.vue?vue&type=script&lang=js"
export * from "./UploadOrRecordPage.vue?vue&type=script&lang=js"
import style0 from "./UploadOrRecordPage.vue?vue&type=style&index=0&id=85456a1e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85456a1e",
  null
  
)

export default component.exports